import React, { Component } from "react";
import { Row, Col, Button, Modal, Input, Select, message, List, Space, Typography } from 'antd';
import { RedoOutlined, SearchOutlined } from '@ant-design/icons';
import CustomAvatar from "../../Widgets/Avatar/Avatar";
import moment from 'moment'


//Paybook
// import SyncWidget from "@paybook/sync-widget";
import SyncWidget from "@syncfy/authentication-widget";
// import "@paybook/sync-widget/dist/widget.css";

const { Text } = Typography;
const axios = require('axios').default;




class ModalRenovarEmpresasSyncfy extends Component {


    constructor(props) {
        super(props);
        this.state = {
            empresas: {
                data: [],
                limit: 20,
                page: 1,

                total: 0,
                pages: 0,
            },
            activo: undefined,
            result: {},
            id_site_organization_type: "56cf4f5b784806cf028b4569"
        }
    }

    componentDidMount() {
        axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
        this.get()
    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.result.id !== this.state.result.id){
            this.update() 
        }
    }

    componentWillUnmount(){
        window.syncWidget = undefined
    }


    get = ({
        page = this.state.empresas.page,
        limit = this.state.empresas.limit,
        search = this.state.search,
    } = this.state.empresas, {empresas} = this.state) => {
        this.setState({empresas: {...empresas, page, limit}, activo: undefined, loading: true, search})
        axios.get('/empresas', {
            params: {
                page,
                limit,
                search,
                con_syncfy: true
            }
        }).then(({data}) => {
            this.setState({
                empresas: {...empresas, ...data}
            })
        }).catch(error => {
            message.error("Error al obtener las empresas")
        }).finally(() => {
            this.setState({loading: false})
        })
    }
    
    /**
     *
     *
     * @param {object} empresa Objecto con los datos de la empresa
     * @memberof ModalRenovarEmpresasSyncfy
     * @name renovate
     * @description Realiza la renovacion de las credenciales Syncfy de una empresa
     */
    renovate = async (empresa) => {
        
                //syncfy_credenciales_id syncfy_cuenta_bancaria_id syncfy_fecha_actualizacion_saldo
        // console.log('cuenta', cuenta);
        // return  
        this.setState({activo: empresa._id})

        // Si ya hay un token, cerramos sesion

        try {
            await this.deleteSession()
        } catch (error) {
            console.log('e', error);
        }
        
        // Iniciar Sesion con Id del usuario
        try{
            const { data } = await axios.get('/syncfy/session', { params: { id_user_syncfy: empresa.syncfy_usuario_id } })
            sessionStorage.setItem('syncfy', data.token)
            axios.defaults.headers.common['syncfy'] = data.token
        }catch(error){
            message.error("Error al iniciar sesión")
            this.update({response: {error}, id: empresa._id})
            this.setState({activo: undefined})
            return
        }
        // Obtener las credenciales
        // Solicitar la renovacion
        this.renderWidget(empresa.syncfy_credenciales_id, empresa._id)

        // this.setState({activo: empresa._id})

        // // Si ya hay un token, cerramos sesion
        // if (sessionStorage.getItem('syncfy')) {
        //     await this.deleteSession()
        // }
        
        // // Iniciar Sesion con Id del usuario
        // try{
        //     const { data } = await axios.get('/syncfy/session', { params: { id_user_syncfy: empresa.syncfy_usuario_id } })
        //     sessionStorage.setItem('syncfy', data.token)
        //     axios.defaults.headers.common['syncfy'] = data.token
        // }catch(error){
        //     message.error("Error al iniciar sesión")
        //     this.update({response: {error}, id: empresa._id})

        //    this.setState({activo: undefined})
        //     return
        // }
        
        // // Obtener las credenciales
        // let credenciales
        // try{
        //     const { data } = await axios.get('/syncfy/user/credentials', {
        //         params: {
        //             id_site_organization_type: this.state.id_site_organization_type
        //         }
        //     })
        //     credenciales = data.data[0]
        //     if(!credenciales) throw new Error("No hay credenciales")
        // }catch(error){
        //     message.error("Error al obtener credenciales")
        //     this.update({response: {error}, id: empresa._id})

        //    this.setState({activo: undefined})
        //     return
        // }

        // // Solicitar la renovacion
        // this.renderWidget(credenciales.id_credential, empresa._id)
    }

    deleteSession = () => {
        return axios.delete('/syncfy/session')
            .then(({ data }) => {
                sessionStorage.removeItem('syncfy')
            })
            .finally(() => console.log('Sessión Eliminada'))
    }

    update = async ({id, response} = this.state.result) => {
        try{
            await axios.put(`/empresas`, { 
                id, 
                estatus: response?.success ? 1 : 2,
                renovacion: true
            })
        }catch(error){
            console.log("ERROR: ", error)
            message.error("Error al actualizar las credenciales de la empresa")
            return
        }finally{
            this.get()
        }
    }

    /**
     *
     *
     * @param {string} credential Credencial de la empresa Syncfy
     * @param {string} empresa_id Identificador de la empresa a renovar
     * @memberof ModalRenovarEmpresasSyncfy
     * @name renderWidget
     * @description Renderiza un widget de Syncfy que realiza la actualizacion de credenciales
     */
    renderWidget = (credential, empresa_id) => {
        if (sessionStorage.getItem('syncfy') && sessionStorage.getItem('syncfy') !== null) {
            if (!window.syncWidget){
                window.syncWidget = new SyncWidget({
                    // Set up the token you created in the Quickstart:	
                    token: sessionStorage.getItem('syncfy'),
                    config: {
                        // Set up the language to use:	
                        locale: 'es',
                        navigation: {
                            displayStatusInToast: true,
                            displaySiteOrganizationTypes: this.state.id_site_organization_type ? [this.state.id_site_organization_type,] : null
                        },
                        entrypoint: {
                            credential: credential ? credential : undefined,
                        }
                    }
                })
            }else {
                window.syncWidget.setConfig({
                    navigation: {
                        displayStatusInToast: true,
                        displaySiteOrganizationTypes: this.state.id_site_organization_type ? [this.state.id_site_organization_type,] : null
                        // displaySiteOrganizationTypes: this.state.id_site_organization_type ? [this.state.id_site_organization_type,] : null
                    },
                    entrypoint: {
                        credential: credential ? credential : undefined,
                    }
                })
                window.syncWidget.setToken(sessionStorage.getItem('syncfy'))
            }

            window.syncWidget.on("error", e => {
                this.setState({result: {id: empresa_id, response: {error: e}}})
            });
            window.syncWidget.on("success", e => {
                this.setState({result: {id: empresa_id, response: {success: e}}})
            });

            if (!credential){
                window.syncWidget.open()
            }
            return
        }
        return Modal.error({
            title: "Debe seleccionar un Usuario de Syncfy para poder generar las credenciales."
        })
    }


    render() {
        const { empresas } = this.state
        return (
            <Row gutter={[24, 24]}>
                <Col xs={24}>
                    <Input
                        allowClear
                        prefix={<SearchOutlined />}
                        placeholder="Buscar Cuenta"
                        value={this.state.search}
                        onChange={(e) => this.get({search: e.target.value})}     
                    />
                </Col>
                <Col xs={24}>
                    <List
                        loading={this.state.loading}
                        itemLayout="horizontal"
                        locale={{ emptyText: "Sin Empresas" }}
                        dataSource={empresas.data}
                        pagination={{
                            current: empresas?.page,
                            pageSize: empresas?.limit,
                            total: empresas?.total,
                            position: 'bottom',
                            className: "flex-left",
                            onChange: (page, limit) => {
                                this.getEmpresas({ page, limit })
                            }
                        }}
                        renderItem={item => (
                            <List.Item className="">
                                <Row className="width-100 " align={"middle"} gutter={[16, 16]}>
                                    <Col xs={2}>
                                        <CustomAvatar 
                                            name={item.alias || item.razon_social} 
                                            color={item.color}
                                            url={ item.logo ? {
                                                url: `${axios.defaults.baseURL}/empresas/${item?._id}`,
                                                logo: item?.logo?.name
                                            } : null}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Space size={2} direction="vertical">
                                            <Text>{item.alias || item.razon_social}</Text>
                                            <Text className="text-gray">{item.rfc}</Text>
                                        </Space>
                                    </Col>
                                    <Col xs={8}>
                                        <Space size={2} direction="vertical">
                                            <Text className="text-gray">Ultima renovación</Text>
                                            <Text>{moment(item.renovacion?.createdAt || item.createdAt).format('YYYY-MM-DD HH:mm')}</Text>
                                        </Space>
                                    </Col>
                                    <Col xs={2}>
                                        <Button
                                            type="primary"
                                            icon={<RedoOutlined />}
                                            title="Renovar"
                                            disabled={this.state.activo && this.state.activo !== item._id}
                                            loading={this.state.activo === item._id}
                                            onClick={() => this.renovate(item)}
                                        />
                                    </Col>
                                </Row>
                            </List.Item>
                        )}
                    />
                </Col>
            </Row>
        )
    }
}


export default function (props) {
    const { visible = false, onClose = () => { }, empresa_id } = props

    return <Modal
        visible={visible}
        onCancel={onClose}
        title={"Renovar Credenciales de Syncfy"}
        destroyOnClose={true}
        footer={null}
    >
        <ModalRenovarEmpresasSyncfy {...props} />
    </Modal>

}